{
  "titles": {
    "summary": "Rekening-courant faciliteit",
    "onboarding": {
      "Welcome": "Welkom bij DebitRoom",
      "QuoteAndFrameworkAgreement": "Documenten ondertekenen",
      "Sepa": "Automatische incasso machtiging",
      "Psd": "Bankrekeningen verbinden",
      "TreatmentFee": "Betaling behandelkosten",
      "completed": "Welkom bij DebitRoom"
    },
    "offboarded": "Rekening-courant faciliteit"
  },
  "messages": {
    "noRole": "Je hebt niet de juiste rol om deze app te gebruiken. Het kan zijn dat je met een verkeerd account bent ingelogd. Heb je het vermoeden dat je wel in deze app zou moeten kunnen, neem dan contact op met DebitRoom.",
    "facilityBlocked": "Faciliteit is tijdelijk niet beschikbaar",
    "offboarded": "Je rekening-courant faciliteit bij DebitRoom is niet meer beschikbaar. Binnen deze app kan je alle leningen én terugbetalingen terugvinden.\n\nIndien je weer gebruik wilt maken van onze faciliteit, neem dan contact op met <a href='{url}'>jouw adviseur</a>.",
    "psd": {
      "completed": "Bedankt! Je hebt je zakelijke bankrekeningen verbonden.",
      "noBankAccounts": "Verbind al je zakelijke bankrekeningen. Zo krijgen we inzicht in je cashflow en kijken we met je mee naar de financiële gezondheid van je bedrijf.\n\nDe koppeling loopt via Ponto, onze partner voor veilige bankverbindingen. Je kunt de bankrekeningen verbinden als je gemachtigd bent en toegang hebt tot de bank.\n\nKlik op de knop hieronder om je rekeningen te verbinden. Zodra dit is gelukt, ronden we deze stap automatisch voor je af.",
      "sepaAccount": "Bedankt! Je hebt je zakelijke bankrekening verbonden.\nHeb je bij meerdere banken een zakelijke rekening? Zorg ervoor dat je deze ook koppelt.",
      "sepaAccountPlural": "Bedankt! Je hebt je zakelijke bankrekeningen verbonden.\nHeb je bij meerdere banken een zakelijke rekening? Zorg ervoor dat je deze ook koppelt.",
      "nonSepaAccount": "Bedankt! Je hebt je zakelijke bankrekening verbonden.\nZorg ervoor dat je de rekening ({sepaIban}) waarop de SEPA-machtiging is afgegeven hier koppelt.",
      "nonSepaAccountPlural": "Bedankt! Je hebt je zakelijke bankrekeningen verbonden.\nZorg ervoor dat je de rekening ({sepaIban}) waarop de SEPA-machtiging is afgegeven hier koppelt.",
      "expectingBankAccounts": "We missen nog een of meerdere bankrekeningen in de koppeling. \n\nHieronder zie je welke rekeningen je hebt gekoppeld en welke we nog missen. Koppel de missende rekening(en) om de aanvraag verder af te ronden."
    },
    "sepa": {
      "active": "We hebben de SEPA-machtiging naar het e-mailadres {email} gestuurd.\n\nMet deze machtiging geef je toestemming om de afgesproken bedragen automatisch van je bankrekening af te schrijven. Je kunt alleen tekenen als je gemachtigd bent en toegang hebt tot de bank.\n\nJe kunt de machtiging ondertekenen via de e-mail of direct via de knop hieronder. Je wordt dan doorgestuurd naar Twikey, onze partner voor het veilig afhandelen van incasso's.\n\nZodra je hebt getekend ronden we deze stap automatisch voor je af.",
      "firstSigner": "Met deze machtiging geef je toestemming om de geleende bedragen automatisch van de bankrekening af te schrijven. Je kunt alleen tekenen als je gemachtigd bent en toegang hebt tot de bank.\n\nJe kunt de machtiging ondertekenen via de knop hieronder. Je wordt dan doorgestuurd naar Twikey, onze partner voor het veilig afhandelen van incasso's.\n\nLet erop dat je geen limiet invult, zodat we de geleende bedragen altijd kunnen afschrijven.\n\nZodra je hebt getekend, ronden we deze stap automatisch voor je af.",
      "notFirstSigner": "We hebben de incasso machtiging naar de medeondertekenaar gestuurd.\n\nMet deze machtiging wordt er toestemming gegeven om de geleende bedragen automatisch van de bankrekening af te schrijven. Er is slechts één ondertekenaar nodig die de machtiging tekent.\n\nZodra de medeondertekenaar heeft getekend, ronden we deze stap automatisch voor je af. Je kunt alvast verder met de volgende stappen.",
      "signed": "De automatische incasso machtiging is succesvol ondertekend. Bedankt!\n\nJe kunt nu verder met de volgende stappen.",
      "printedNotSigned": "Jouw bank ondersteunt geen digitale incasso machtiging.\n\nIn je e-mail heb je een SEPA-formulier ontvangen om de machtiging handmatig bij jouw bank te registreren. Download of print dit formulier, vul de ontbrekende gegevens in en stuur het naar jouw bank.\n\nNa enkele dagen / weken (verschilt per bank) ontvang je een schriftelijke bevestiging van de registratie van je bank. Om de automatische incasso machtiging te activeren, ontvangen wij graag een kopie van deze bevestiging.\nOm de aanvraag nu verder af te ronden, ontvangen wij graag een kopie van het ingevulde én ondertekende SEPA-formulier.\n\nStuur een kopie van het SEPA-formulier naar:",
      "confirmPrinted": "Ik heb een kopie van het ingevulde én ondertekende SEPA-formulier verzonden naar DebitRoom.",
      "insufficientLimit": "Helaas ging er iets mis en kunnen we de machtiging niet verwerken.\n\nDe reden hiervoor is:\n{reason}\n\nWe verzoeken je opnieuw de machtiging in te voeren via de onderstaande knop en geen incassolimiet in te stellen.",
      "retryReason": {
        "InsufficientLimit": "Je hebt een incasso-limiet ingesteld waardoor er mogelijk in de toekomst problemen optreden bij het incasseren op jouw bankrekening."
      }
    },
    "onboarding": {
      "welcome": "Beste {name}, \n\nJe partner {partnerName} heeft namens {companyName} een kredietaanvraag ingediend. Wij hebben deze aanvraag positief beoordeeld en bieden je graag een krediet aan!\n\nIn deze app vind je alle informatie over jouw leningen en incasso's. Voordat we verder kunnen, vragen we je om eerst een aantal zaken te regelen. Kom je er niet uit, neem dan gerust contact met ons op, we helpen je graag verder.\n\nVeel succes!\nTeam DebitRoom",
      "quote": {
        "noCreditLimit": "We zijn nog bezig met het opstellen van de offerte. Kom binnenkort terug!",
        "singleSigner": "We hebben de offerte en raamovereenkomst naar je e-mailadres gestuurd. In de offerte vind je ons aanbod en alle details. In de raamovereenkomst leggen we de algemene afspraken vast die gelden voor je lening(en), zoals de voorwaarden, rechten en plichten van beide partijen.\n\nJe kunt de offerte en raamovereenkomst ondertekenen via de e-mail of direct via de knop hieronder. Je wordt dan doorgestuurd naar Stiply, onze partner voor het digitaal ondertekenen van contracten.\n\nZodra je hebt getekend, ronden we deze stap automatisch voor je af.",
        "multiSignerFirst": "We hebben de offerte en raamovereenkomst naar je e-mailadres gestuurd. In de offerte vind je ons aanbod en alle details. In de raamovereenkomst leggen we de algemene afspraken vast die gelden voor je lening(en), zoals de voorwaarden, rechten en plichten van beide partijen.\n\nJe kunt de offerte en raamovereenkomst ondertekenen via de e-mail of direct via de knop hieronder. Je wordt dan doorgestuurd naar Stiply, onze partner voor het digitaal ondertekenen van contracten.\n\nZodra je hebt getekend, wordt de offerte naar de medeondertekenaars gestuurd.\nZodra alle benodigde ondertekenaars hebben getekend ronden we deze stap automatisch voor je af.",
        "multiSignerWaiting": "We hebben de offerte en raamovereenkomst verstuurd naar de medeondertekenaar. Zodra deze is getekend versturen we de offerte en raamovereenkomst naar je e-mailadres zodat je deze kan inzien en tekenen.\n\nZodra alle benodigde ondertekenaars hebben getekend ronden we deze stap automatisch voor je af.",
        "multiSignerSigned": "Je hebt de offerte en raamovereenkomst succesvol getekend. Bedankt!\n\nZodra alle benodigde ondertekenaars hebben getekend ronden we deze stap automatisch voor je af.",
        "allSigned": "De offerte en raamovereenkomst zijn succesvol ondertekend. Bedankt!\n\nJe kunt nu verder met de volgende stappen."
      },
      "treatmentFee": {
        "intro": "Om de aanvraag digitaal af te ronden, willen we je verzoeken de behandelkosten t.w.v. {amount} te voldoen.\n\nDeze kan je voldoen door direct online een betaling te verrichten. Druk op de onderstaande knop om de betaling te starten.",
        "InProgress": "We hebben de bevestiging van je betaling nog niet ontvangen. Dit kan enkele minuten duren.\nZodra we de bevestiging hebben ontvangen, ronden we deze stap automatisch voor je af.\n\nBetaling onderbroken? Start hier de betaling opnieuw.",
        "Completed": "De betaling is ontvangen, je wordt automatisch doorgestuurd naar de volgende stap.",
        "Expired": "Helaas er ging iets mis!\n\nDe vorige betaalpoging is niet afgerond binnen de toegestane tijd en daardoor verlopen.\nOm de aanvraag digitaal af te ronden, willen we je verzoeken de behandelkosten t.w.v. {amount} opnieuw te voldoen.\n\nDruk op de onderstaande knop om een nieuwe betaling te starten of neem contact met ons op.",
        "Failed": "Helaas er ging iets mis!\n\nDe vorige betaalpoging is niet gelukt en hebben wij geen betaling ontvangen. Om de aanvraag digitaal af te ronden, willen we je verzoeken de behandelkosten t.w.v. {amount} alsnog te voldoen. \n\nDruk op de onderstaande knop om de betaling opnieuw te starten of neem contact met ons op.",
        "Cancelled": "Helaas er ging iets mis!\n\nDe vorige betaalpoging is afgebroken en hebben wij geen betaling ontvangen. Om de aanvraag digitaal af te ronden, willen we je verzoeken de behandelkosten t.w.v. {amount} alsnog te voldoen. \n\nDruk op de onderstaande knop om de betaling opnieuw te starten of neem contact met ons op."
      },
      "completed": {
        "completed": "Geweldig! Je hebt alle benodigde stappen succesvol doorlopen.",
        "quoteSigned": "Offerte getekend",
        "frameworkAgreementSigned": "Raamovereenkomst getekend",
        "sepaSigned": "Incasso machtiging gegeven",
        "bankConnected": "Bankrekening verbonden",
        "feePaid": "Behandelkosten betaald",
        "facilityAvailable": "Zodra DebitRoom alle documenten en informatie omtrent de aanvraag heeft ontvangen en verwerkt kun je gebruik maken van je faciliteit. \n\n Heb je vragen? \n Neem dan contact met ons op via:",
        "facilityAvailableCanEnterApp": "Bij DebitRoom is alles omtrent de aanvraag ontvangen en goed verwerkt.\n\nJe kan nu gebruik maken van je faciliteit!",
        "faq": "Wil je alvast lezen hoe alles werkt?\nBekijk naar onze veelgestelde vragen",
        "faqCanEnterApp": "Hulp nodig?\n Ga naar onze veelgestelde vragen"
      }
    }
  },
  "errors": {
    "messages": {
      "403": "Er is geen MKB financierder gekoppeld aan jouw account, terwijl dit mogelijk wel had moeten gebeuren. Neem contract op met DebitRoom."
    }
  },
  "actions": {
    "requestLoan": "Lening aanvragen",
    "signButton": "Documenten ondertekenen",
    "retrySignButton": "Ondertekenen opnieuw starten",
    "signSepaButton": "Incasso machtiging tekenen",
    "goToApp": "Ga naar Mijn DebitRoom app",
    "connectPsd": "Bankrekeningen verbinden",
    "payTreatmentFee": "Betaal behandelkosten",
    "viewAllLoans": "Bekijk alle leningen",
    "signSepa": "Incasso machtiging tekenen"
  },
  "facility": {
    "titles": {
      "withdrawnAmount": "Reeds in gebruik",
      "requestedAmount": "In aanvraag"
    },
    "legend": {
      "withdrawnAmount": "In gebruik",
      "requestedAmount": "In aanvraag"
    },
    "fields": {
      "labels": {
        "creditLimit": "Kredietlimiet",
        "withdrawnAmount": "Reeds in gebruik",
        "requestedAmount": "Reeds aangevraagd",
        "availableAmount": "Beschikbaar krediet",
        "interestRate": "Tarief per 30 dagen",
        "totalOverdueAmount": "Totaal openstaand bedrag"
      }
    }
  },
  "loans": {
    "titles": {
      "active": "Jouw leningen",
      "inactive": "Afgewikkelde leningen",
      "withAttentionWhileClientDelinquent": "Leningen in gebreke",
      "withAttention": "Leningen te laat betaald",
      "noLoans": "Geen leningen",
      "extraCostsSpecification": "Extra kosten specificatie",
      "renewalCosts": "Verlengkosten",
      "overdueRenewalCosts": "Verlengkosten na te late betaling",
      "requestLoan": "Lening aanvragen",
      "creditSpace": "Beschikbare kredietruimte",
      "availableForRequest": "Nog beschikbaar",
      "quote": "Samenvatting",
      "upcomingDirectDebits": "Aankomende incasso's",
      "earlyRepayment": "Lening eerder terugbetalen",
      "extendLoan": "Lening verlengen",
      "completedLoans": "Voltooide leningen"
    },
    "fields": {
      "labels": {
        "amount": "Leningbedrag",
        "totalOpenAmount": "Totaal over te maken bedrag",
        "interestRate": "Tarief per 30 dagen",
        "interestAmount": "Financieringskosten",
        "paymentAmount": "Uitbetaald bedrag",
        "durationInDays": "Looptijd",
        "startDate": "Startdatum",
        "reason": "Waarom wil je de lening verlengen?",
        "renewalCosts": {
          "interestAmount": "Financieringskosten",
          "interestAmountIncrease": "Verschil tarief",
          "administrationCosts": "Administratiekosten",
          "totalRenewalCost": "Totaal"
        },
        "expectedStartDate": "Verwachte startdatum",
        "collectionDate": "Incassodatum",
        "previousLoan": "Vorige lening",
        "toBePaid": "Uit te betalen",
        "refundedOn": "Volledig betaald op",
        "invoice": "Factuur",
        "iban": "IBAN",
        "attn": "Ter attentie van",
        "referenceNumber": "Referentie",
        "extraCostsSpecification": {
          "defaultingSince": "In gebreke sinds",
          "defaultingDays": "Aantal dagen in gebreke",
          "defaultingAmount": "Openstaande hoofdsom",
          "penaltyRate": "Boetetarief per 30 dagen",
          "penaltyAmount": "Boeterente",
          "administrationCosts": "Administratiekosten",
          "totalExtraCostsTransferred": "Totaal extra kosten voldaan",
          "totalOpenDebt": "Totaal openstaand bedrag"
        },
        "renewalCostsSpecification": {
          "interestAmount": "Financieringskosten",
          "interestAmountIncrease": "Verschil tarief",
          "administrationCosts": "Administratiekosten",
          "penaltyAmount": "Boeterente",
          "totalOverdueAmount": "Totaal"
        }
      },
      "validationErrors": {
        "reason": {
          "required": "De reden is verplicht"
        }
      }
    },
    "messages": {
      "noLoans": "Er zijn geen leningen beschikbaar",
      "directDebitOn": "Incasso op {on}",
      "directDebitMissedOn": "Incasso gemist op {on}",
      "directDebitRefundedOn": "Volledig betaald op {on}",
      "renewedOn": "Verlengd per {on}",
      "renewalOn": "Verlenging per {on}",
      "withAttentionWhileClientDelinquent": "Je bent in gebreke, betaal zo snel mogelijk terug om meer kosten te voorkomen.",
      "withAttention": "Je hebt een incasso gemist, betaal zo snel mogelijk terug om meer kosten te voorkomen.",
      "maxAvailable": "Maximaal beschikbaar: {amount}",
      "insufficientCredit": "Onvoldoende kredietruimte",
      "insufficientCreditBody": "Er is momenteel onvoldoende ruimte beschikbaar in je faciliteit. De minimale hoogte van een lening is {minAmount} en er is momenteel {availableAmount} beschikbaar binnen je faciliteit.",
      "noQuote": "Er is nog geen offerte beschikbaar, vul bovenstaand formulier in om een offerte in te zien",
      "upcomingDirectDebits": "De volgende leningen worden binnenkort geïncasseerd. Zorg voor voldoende saldo.",
      "confirmationDialog": "Wil je de leningaanvraag intrekken?",
      "extendLoanDisclaimer": "Wanneer je de lening verlengt komt de aanvraag bij ons binnen ter goedkeuring. Wanneer we akkoord gaan dan:",
      "extendLoanDisclaimerBulletPoints": "<li>Betaal je de rentekosten van afgelopen lening</li><li>Betaal je extra administratiekosten</li><li>Vervallen de incasso's voor de huidige lening,</li><li>Los je de huidige lening af met een nieuwe lening</li><li>De nieuwe lening heeft dezelfde voorwaarde als de huidige lening</li>",
      "renewalQuote": "Kosten voor verlenging",
      "maxRenewalRequestDate": "Verlengen mogelijk tot en met {date}.",
      "requestLoanDisclaimer": "Alle leningen zullen eerst worden beoordeeld door ons team. Zodra de lening is goedgekeurd zal de lening worden uitbetaald en ontvang je hier een bericht van in de berichtenbox",
      "earlyRepaymentDisclaimer": "Wil je de lening eerder terugbetalen? Dat mag.\nMaak het hele leningbedrag over. Zodra je kiest voor het definitief terugbetalen, worden wij geïnformeerd en krijg je de gegevens waar je het geld naartoe over kan maken in je berichtenbox. Wij zullen per omgaande de betaling verwerken en dan is deze lening afgesloten.\n\nLet wel, indien je niet (volledig) overmaakt, blijven de huidige incasso's staan en loopt de lening verder.\n\nWeet je zeker dat je de lening eerder wil terugbetalen?",
      "earlyRepaymentRequested": "Eerder betalen: neem actie",
      "earlyRepaymentRequestedBody": "Je verzoek om eerder terug te betalen is ontvangen. Maak het volledige bedrag over om de lening af te lossen.",
      "hasPendingRenewalRequest": "Verlenging in behandeling",
      "hasExpiredRenewalRequest": "Verlengverzoek is verlopen",
      "hasRejectedRenewalRequest": "Verlengverzoek is afgewezen",
      "hasCancelledRenewalRequest": "Verlengverzoek is geannuleerd",
      "isRenewedWithLoan": "Verlengverzoek is uitgevoerd met lening",
      "hasApprovedRenewalRequest": "Verlenging akkoord",
      "hasApprovedRenewalRequestTakeAction": "Verlenging akkoord: neem actie",
      "hasApprovedRenewalRequestBody": "Deze lening wordt verlengd zodra de financierings- en administratiekosten zijn betaald en verwerkt. Er verschijnt automatisch een nieuwe lening met een nieuw incassomoment. Deze lening wordt afgesloten.",
      "renewalRequestreferenceNumberDescription": "{referenceNumber} verlengen"
    },
    "errors": {
      "validation": {
        "withinCreditLimit": "Het bedrag van de lening mag niet hoger zijn dan het beschikbare krediet",
        "validCollectionDate": "Op deze datum kunnen banken geen incasso's uitvoeren. Kies een andere datum.",
        "minDate": "De incassodatum moet minimaal 30 dagen vanaf nu zijn",
        "maxDate": "De incassodatum mag maximaal 90 dagen vanaf nu zijn"
      }
    },
    "actions": {
      "showInactive": "Toon historie",
      "viewAll": "Bekijk alle leningen",
      "back": "Terug naar leningen",
      "requestLoan": "Lening aanvragen",
      "delete": "Lening intrekken",
      "earlyRepayment": "Eerder terugbetalen",
      "extend": "Lening verlengen",
      "cancel": "Annuleren"
    }
  },
  "bankConnections": {
    "titles": {
      "bankConnections": "Bankverbindingen",
      "sepaBankAccounts": "Incassorekening",
      "otherBankAccounts": "Overige rekeningen"
    },
    "labels": {
      "holder": "t.n.v. {name}",
      "connectedSince": "Verbinding sinds:",
      "connectedUntil": "Verbinding verloopt op:"
    },
    "errors": {
      "messages": {
        "reauthorizationFailed": "Het is niet gelukt om de koppeling te herauthoriseren.",
        "connectionFailed": "Het is niet gelukt om de rekening te koppelen.",
        "addBankAccountFailed": "Het is niet gelukt om een nieuwe bankrekening te koppelen.",
        "accountInUse": "Het Ponto account is al in gebruik, gebruik een ander Ponto account om bankrekeningen te kunnen verbinden."
      }
    },
    "messages": {
      "sepaBankAccounts": "Dit is de rekening waar de incasso's plaatsvinden. Zorg dat de automatische incassomachtiging altijd up-to-date en verbonden is.",
      "otherBankAccounts": "Dit zijn al je overige zakelijke bankrekeningen. Zorg dat deze compleet zijn, zodat we kunnen meekijken naar de financiële gezondheid van je bedrijf.",
      "authorizationExpiringSoon": "De verbinding verloopt bijna. Herautoriseer de toegang zodat je gebruik kan blijven maken van je krediet.",
      "authorizationExpired": "De verbinding is verlopen. Herautoriseer de toegang zodat je weer gebruik kan maken van je krediet.",
      "reauthorizationInProgress": "De verbinding(en) worden geherautoriseerd. Het kan enkele minuten duren voordat dit zichtbaar is in de app.",
      "bankAccountNeedsConnection": "We verzoeken je deze rekening te koppelen"
    },
    "actions": {
      "add": "Bankrekening toevoegen",
      "reauthorize": "Rekening herautoriseren",
      "connect": "Rekening koppelen"
    }
  }
}
